import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import Orders from "./views/Orders.vue";
import Order from "./views/Order.vue";
import Picking from "./views/Picking.vue";
import Dispatch from "./views/Dispatch.vue";
import Stock from "./views/Stock.vue";
import StockLog from "./views/StockLog.vue";
import StockAdd from "./views/StockAdd.vue";
import StockEdit from "./views/StockEdit.vue";
import Packages from "./views/Packages.vue";
import PackageAdd from "./views/PackageAdd.vue";
import Payments from "./views/Payments.vue";
import Shipments from "./views/Shipments.vue";
import Shipping from "./views/Shipping.vue";
import ShippingAllocation from "./views/ShippingAllocation.vue";
import ShipmentAdd from "./views/ShipmentAdd.vue";
import ShipmentEdit from "./views/ShipmentEdit.vue";
import ShipmentStock from "./views/ShipmentStock.vue";
import Mappings from "./views/Mappings.vue";
import MappingsAdd from "./views/MappingsAdd.vue";
import MappingsEdit from "./views/MappingsEdit.vue";
import Ingredients from "./views/Ingredients.vue";
import IngredientAdd from "./views/IngredientAdd.vue";
import IngredientEdit from "./views/IngredientEdit.vue";
import RawShipments from "./views/RawShipments.vue";
import RawShipmentAdd from "./views/RawShipmentAdd.vue";
import RawShipmentEdit from "./views/RawShipmentEdit.vue";
import RawShipmentProduct from "./views/RawShipmentProduct.vue";
import TestingRequests from "./views/TestingRequests";
import TestingRequestAdd from "./views/TestingRequestAdd.vue";
import TestingRequestEdit from "./views/TestingRequestEdit.vue";
import TestingRequestSample from "./views/TestingRequestSample.vue";
import Envelopes from "./views/Envelopes.vue";
import EnvelopesAdd from "./views/EnvelopesAdd.vue";
import EnvelopesEdit from "./views/EnvelopesEdit.vue";
import TrackingNumbers from "./views/TrackingNumbers.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/order/:id",
      name: "order",
      component: Order,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/order/:id/pick",
      name: "picking",
      component: Picking,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stock/",
      name: "stock",
      component: Stock,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stock/add",
      name: "stock-add",
      component: StockAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stock/:id/log",
      name: "stock-log",
      component: StockLog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stock/:id/edit",
      name: "stock-edit",
      component: StockEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/packages/",
      name: "packages",
      component: Packages,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipments/",
      name: "shipments",
      component: Shipments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipping/",
      name: "shipping",
      component: Shipping,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipping/:id",
      name: "shipping-allocation",
      component: ShippingAllocation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipments/add",
      name: "shipment-add",
      component: ShipmentAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipments/:id/edit",
      name: "shipment-edit",
      component: ShipmentEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shipments/:id/stock",
      name: "shipment-stock",
      component: ShipmentStock,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/packages/add",
      name: "package-add",
      component: PackageAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dispatch",
      name: "dispatch",
      component: Dispatch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/payments",
      name: "payments",
      component: Payments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/mappings",
      name: "mappings",
      component: Mappings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/mappings/add",
      name: "mappings-add",
      component: MappingsAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/mappings/:id/edit",
      name: "mappings-edit",
      component: MappingsEdit,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/ingredients",
      name: "ingredients",
      component: Ingredients,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ingredients/add",
      name: "ingredients-add",
      component: IngredientAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ingredients/:id/edit",
      name: "ingredients-edit",
      component: IngredientEdit,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/raw/shipments",
      name: "raw-shipments",
      component: RawShipments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/raw/shipments/add",
      name: "raw-shipments-add",
      component: RawShipmentAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/raw/shipments/:id/edit",
      name: "raw-shipments-edit",
      component: RawShipmentEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/raw/shipments/:id/product",
      name: "raw-shipment-stock",
      component: RawShipmentProduct,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/testing/requests",
      name: "testing-requests",
      component: TestingRequests,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/testing/requests/add",
      name: "testing-requests-add",
      component: TestingRequestAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/testing/requests/:id/edit",
      name: "testing-requests-edit",
      component: TestingRequestEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/testing/requests/:id/sample",
      name: "testing-requests-sample",
      component: TestingRequestSample,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true
      }
    },

    {
      path: "/envelopes",
      name: "envelopes",
      component: Envelopes,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/envelopes/add",
      name: "envelopes-add",
      component: EnvelopesAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/envelopes/:id/edit",
      name: "envelopes-edit",
      component: EnvelopesEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tracking-numbers",
      name: "tracking-numbers",
      component: TrackingNumbers,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      // let user = JSON.parse(localStorage.getItem("user"));
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem("jwt") == null) {
      next();
    } else {
      next({ name: "dashboard" });
    }
  } else {
    next();
  }
});

export default router;
